"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_INITIAL_QUANTITY = exports.MANUAL_REPLACEMENT = exports.FETCH_MODE_LAZY = exports.FETCH_MODE_EAGER = void 0;
const FETCH_MODE_EAGER = exports.FETCH_MODE_EAGER = 'eager';
const FETCH_MODE_LAZY = exports.FETCH_MODE_LAZY = 'lazy';
const PRODUCT_INITIAL_QUANTITY = exports.PRODUCT_INITIAL_QUANTITY = 1;
const MANUAL_REPLACEMENT = exports.MANUAL_REPLACEMENT = 'M';